import { ProfileOperationsListComponent } from '@frontend/profile/operations/list/list.component';

export const profileOperationsRoutes = {
  path: 'operations',
  component: ProfileOperationsListComponent
};